<div class="si-edit-container">
  <!-- LOADER -->
  <app-loader *ngIf="isLoading"></app-loader>
  <!-- FORM -->
  <form class="si-edit-form" #editform="ngForm" (ngSubmit)="onSubmit(editform)">
    <!-- HEADER  -->

    <div class="si-edit-header">
      <!-- TITLE  -->
      <span class="si-edit-title">
        {{ (ticketHeader.ticketId ? "module.ticket.edit.title_update" : "module.ticket.edit.title_create") | translate }}
      </span>
      <!-- BOUTON USER PRESET -->
      <button kendoButton fillMode="flat" themeColor="primary" [svgIcon]="allIcons.listLatinBigIcon" type="button" (click)="openPresetPopup()">Preset</button>
      <!-- CLOSE BTN  -->
      <button kendoButton fillMode="flat" themeColor="secondary" [svgIcon]="allIcons.xIcon" type="button" (click)="fermer()"></button>
    </div>

    <!-- CONTENT -->

    <div class="si-edit-content">
      <!--<div class="si-edit-content-button"></div>-->

      <!-- ROW -->

      <fieldset class="si-edit-fieldset-row">
        <!-- ID -->

        <div class="si-formfield" style="width: 70px">
          <kendo-label [for]="ticketId" [text]="'module.ticket.model.ticketId' | translate"></kendo-label>
          <input kendoTextBox name="ticketId" [(ngModel)]="ticketHeader.ticketId" #ticketId readonly class="si-input-readonly" />
        </div>

        <!-- DATE -->

        <div class="si-formfield" style="width: 120px">
          <kendo-label [text]="'module.ticket.model.openingDate' | translate"> </kendo-label>
          <input kendoTextBox name="openingDate" [value]="this.ticketHeader.openingDate" readonly />
        </div>

        <!-- PRIORITÉ -->

        <div class="si-formfield" style="width: 140px">
          <kendo-label [for]="scPriorityId" [text]="'module.ticket.model.scPriorityId' | translate"></kendo-label>
          <kendo-dropdownlist
            #scPriorityId
            name="scPriorityId"
            [data]="priorityList"
            [valuePrimitive]="true"
            [textField]="'description'"
            [valueField]="'idPriorite'"
            [(ngModel)]="ticketHeader.scPriorityId"
            [disabled]="isLoading"
          >
            <ng-template kendoComboBoxItemTemplate let-dataItem>
              <app-ticket-header-priority [priority]="dataItem.idPriorite" [description]="dataItem.description"></app-ticket-header-priority>
            </ng-template>
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <ng-container *ngIf="dataItem">
                <app-ticket-header-priority [priority]="ticketHeader.scPriorityId" [description]="dataItem.description"></app-ticket-header-priority>
              </ng-container>
            </ng-template>
          </kendo-dropdownlist>
        </div>

        <!-- STATUT -->

        <div class="si-formfield" style="flex: 1">
          <kendo-label [for]="scTicketStatusCode" [text]="'module.ticket.model.scTicketStatusCode' | translate"></kendo-label>
          <kendo-dropdownlist
            #scTicketStatusCode
            name="scTicketStatusCode"
            [data]="ticketStatusList"
            [valuePrimitive]="true"
            [textField]="'ServicentreTextualCode'"
            [valueField]="'ServicentreTextualCode'"
            [(ngModel)]="ticketHeader.scTicketStatusCode"
            [disabled]="isLoading"
          >
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <ng-container *ngIf="dataItem">{{ ticketHeader.scTicketStatusCode }}</ng-container>
            </ng-template>
          </kendo-dropdownlist>
        </div>

        <!-- État (ouvert/fermé) -->

        <div class="si-formfield" style="width: 70px">
          <kendo-label [text]="'module.ticket.model.isClosedOrOpen' | translate"></kendo-label>
          @if(ticketHeader.ticketId) {
          <input
            kendoTextBox
            name="isClosed"
            [ngClass]="ticketHeader.isClosed ? 'input-etat-ticket-closed' : 'input-etat-ticket-opened'"
            [value]="(ticketHeader.isClosed ? 'module.ticket.edit.value_closed' : 'module.ticket.edit.value_opened') | translate"
            readonly
            class="si-input-readonly"
          />
          }
        </div>
      </fieldset>

      <!-- ROW -->

      <fieldset class="si-edit-fieldset-row">
        <!-- CLIENT -->

        <div class="si-formfield" style="flex: 2">
          <kendo-label [for]="customerName" [text]="'module.ticket.model.customer' | translate"></kendo-label>
          <kendo-textbox [(ngModel)]="customerName" name="customerName" [readonly]="true"></kendo-textbox>
          <!-- ONHOLD : CHAMPS AVEC RECHERCHE CLIENT
          <kendo-textbox [(ngModel)]="customerName" name="customerName" [readonly]="true" (click)="selectCustomer()" class="si-input-pointer">
            <ng-template kendoTextBoxSuffixTemplate>
              <button kendoButton fillMode="clear" [svgIcon]="allIcons.searchIcon" type="button"></button>
            </ng-template>
          </kendo-textbox>
          -->
        </div>

        <!-- NO CONTRAT -->

        <div class="si-formfield" style="flex: 1">
          <kendo-label [for]="serviceContractId" [text]="'module.ticket.model.serviceContractId' | translate"></kendo-label>
          <input kendoTextBox name="serviceContractId" [(ngModel)]="ticketHeader.serviceContractId" #serviceContractId readonly class="si-input-readonly" />
        </div>

        <!-- PO NUMBER -->

        <div class="si-formfield" style="flex: 1">
          <kendo-label [for]="scTicketPONumber" [text]="'module.ticket.model.scTicketPONumber' | translate"></kendo-label>
          <input kendoTextBox name="scTicketPONumber" [(ngModel)]="ticketHeader.scTicketPONumber" #scTicketPONumber maxlength="30" />
        </div>
      </fieldset>

      <!-- ROW -->

      <fieldset class="si-edit-fieldset-row">
        <!-- CATEGORIE -->

        <div class="si-formfield" style="flex: 1">
          <kendo-label [for]="scInvoicingCategoryCode" [text]="'module.ticket.model.scInvoicingCategoryCode' | translate"></kendo-label>
          <kendo-dropdownlist
            #scInvoicingCategoryCode
            name="scInvoicingCategoryCode"
            [data]="invoicingCategoryList"
            [valuePrimitive]="true"
            [textField]="'categoryCode'"
            [valueField]="'categoryCode'"
            [filterable]="true"
            [(ngModel)]="ticketHeader.scInvoicingCategoryCode"
            [kendoDropDownFilter]="invoicingCategoryFilterSettings"
            [disabled]="isLoading"
            required
          >
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <ng-container *ngIf="dataItem">{{ ticketHeader.scInvoicingCategoryCode }}</ng-container>
            </ng-template>
          </kendo-dropdownlist>
        </div>

        <!-- TYPE D'APPEL -->

        <div class="si-formfield" style="flex: 1">
          <kendo-label [for]="scTicketType" [text]="'module.ticket.model.scTicketType' | translate"></kendo-label>
          <kendo-dropdownlist
            #scTicketType
            name="scTicketType"
            [data]="ticketTypeList"
            [valuePrimitive]="true"
            [textField]="'ServicentreTextualCode'"
            [valueField]="'ServicentreTextualCode'"
            [filterable]="true"
            [(ngModel)]="ticketHeader.scTicketType"
            [kendoDropDownFilter]="ticketTypeFilterSettings"
            [disabled]="isLoading"
            required
          >
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <ng-container *ngIf="dataItem">{{ ticketHeader.scTicketType }}</ng-container>
            </ng-template>
          </kendo-dropdownlist>
        </div>

        <!-- LOCALISATION -->

        <div class="si-formfield" style="flex: 1">
          <kendo-label [for]="scLocalisation" [text]="'module.ticket.model.scLocalisation' | translate"></kendo-label>
          <kendo-dropdownlist
            #scLocalisation
            name="scLocalisation"
            [data]="localisationList"
            [valuePrimitive]="true"
            [textField]="'localisation'"
            [valueField]="'localisation'"
            [(ngModel)]="ticketHeader.scLocalisation"
            [disabled]="isLoading"
            required
          >
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <ng-container *ngIf="dataItem">{{ ticketHeader.scLocalisation }}</ng-container>
            </ng-template>
          </kendo-dropdownlist>
        </div>
      </fieldset>

      <!-- ROW -->

      <fieldset class="si-edit-fieldset-row">
        <!-- CONTACT -->

        <div class="si-formfield" style="flex: 1">
          <kendo-label [for]="customerContactName" [text]="'module.ticket.model.customerContactName' | translate"></kendo-label>
          <input kendoTextBox name="customerContactName" [(ngModel)]="ticketHeader.customerContactName" #customerContactName required maxlength="30" />
        </div>
        <!-- TELEPHONE CONTACT -->

        <div class="si-formfield" style="flex: 1">
          <kendo-label [for]="customerContactPhone" [text]="'module.ticket.model.customerContactPhone' | translate"></kendo-label>
          <input kendoTextBox name="customerContactPhone" [(ngModel)]="ticketHeader.customerContactPhone" #customerContactPhone maxlength="20" />
        </div>
      </fieldset>

      <!-- ROW -->

      <fieldset class="si-edit-fieldset-row">
        <!-- ASSIGNÉ À -->

        <div class="si-formfield" style="flex: 1">
          <kendo-label [for]="sC_Ticket_AssignedTo_UserCode" [text]="'module.ticket.model.sC_Ticket_AssignedTo_UserCode' | translate"></kendo-label>
          <kendo-dropdownlist
            #sC_Ticket_AssignedTo_UserCode
            name="sC_Ticket_AssignedTo_UserCode"
            [data]="technicianList"
            [valuePrimitive]="true"
            [textField]="'FullName'"
            [valueField]="'TechnicianCode'"
            [filterable]="true"
            [(ngModel)]="ticketHeader.sC_Ticket_AssignedTo_UserCode"
            [kendoDropDownFilter]="technicianFilterSettings"
            [disabled]="isLoading"
            required
          >
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <ng-container>{{ ticketHeader.sC_Ticket_AssignedTo_UserCode | getTechnicianName : technicianList }}</ng-container>
            </ng-template>
          </kendo-dropdownlist>
        </div>

        <!-- CREE PAR -->

        <div class="si-formfield" style="flex: 1">
          <kendo-label [for]="sC_Ticket_CreatedBy_UserCode" [text]="'module.ticket.model.sC_Ticket_CreatedBy_UserCode' | translate"></kendo-label>
          <kendo-dropdownlist
            #sC_Ticket_CreatedBy_UserCode
            name="sC_Ticket_CreatedBy_UserCode"
            [data]="technicianList"
            [valuePrimitive]="true"
            [textField]="'FullName'"
            [valueField]="'TechnicianCode'"
            [filterable]="true"
            [(ngModel)]="ticketHeader.sC_Ticket_CreatedBy_UserCode"
            [kendoDropDownFilter]="technicianFilterSettings"
            [disabled]="isLoading"
            required
          >
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <ng-container> {{ ticketHeader.sC_Ticket_CreatedBy_UserCode | getTechnicianName : technicianList }}</ng-container>
            </ng-template>
          </kendo-dropdownlist>
        </div>
      </fieldset>

      <!-- ROW -->

      <fieldset class="si-edit-fieldset">
        <!-- TITLE -->

        <div class="si-formfield">
          <kendo-label [for]="scTicketShortTitle" [text]="'module.ticket.model.scTicketShortTitle' | translate"></kendo-label>
          <input
            kendoTextBox
            name="scTicketShortTitle"
            [(ngModel)]="ticketHeader.scTicketShortTitle"
            #scTicketShortTitle
            class="si-ticket-header-title"
            maxlength="30"
            required
          />
        </div>
      </fieldset>

      <!-- ROW -->

      <fieldset class="si-edit-fieldset">
        <!-- SHORT DESCRIPTION : INPUT -->

        <div class="si-formfield">
          <kendo-label [for]="scGlobalComment" [text]="'module.ticket.model.scGlobalComment' | translate"></kendo-label>
          <textarea #scGlobalComment name="scGlobalComment" [(ngModel)]="ticketHeader.scGlobalComment" class="si-input-textarea" rows="3"></textarea>
        </div>
        <!-- SHORT DESCRIPTION : TEXTAREA (OLD VERSION)
        <kendo-expansionpanel [title]="'module.fdt.edit.label_ticket_detail' | translate">
          <div class="si-ticket-header-servicentre-comment-container">
            <textarea kendoTextBox [value]="ticketHeader.scGlobalComment" readonly class="si-ticket-header-servicentre-comment si-input-readonly"></textarea>
          </div>
        </kendo-expansionpanel>
         -->
      </fieldset>

      @if(ticketHeader.ticketId) { @if (scTechnicianCode || ticketDetailDate || ticketDetailDateStart) {
      <!-- FILTRE COURANT -->

      <div class="si-detail-filter-container">
        <div class="si-detail-filter-label">{{ "module.fdt.edit.label_active_filter" | translate }} :</div>
        <div *ngIf="scTechnicianCode">
          {{ "module.fdt.edit.label_filter_employee" | translate }} : <b>{{ scTechnicianCode }}</b
          >,
        </div>
        <div *ngIf="ticketDetailDate">
          {{ "module.fdt.edit.label_filter_date" | translate }} : <b>{{ ticketDetailDate }}</b>
        </div>
        <div *ngIf="ticketDetailDateStart">
          {{ "module.fdt.edit.label_filter_date_from" | translate }} <b>{{ ticketDetailDateStart }}</b> {{ "module.fdt.edit.label_filter_date_to" | translate }}
        </div>
        <div *ngIf="ticketDetailDateEnd">
          <b>{{ ticketDetailDateEnd }}</b>
        </div>
      </div>
      }

      <!-- DETAILS -->

      <div class="si-edit-section-container">
        <div class="si-edit-section-title-container">
          <div class="si-edit-section-title">
            {{ "module.ticket.edit.label_comment" | translate }}
            <!-- BOUTON AJOUTER COMMENTAIRE -->
            @if(!ticketHeader.isClosed) {
            <button kendoButton [svgIcon]="allIcons.plusIcon" themeColor="primary" (click)="addComment()" type="button"></button>
            }
          </div>
          <div class="si-edit-section-total-hours">
            <div>
              Total Hrs: <b>{{ totalHours }}</b>
            </div>
          </div>
        </div>

        <!-- LISTE DES COMMENTAIRE -->

        @for (myTicketDetailData of ticketDetailList; track myTicketDetailData.lineNumber) {

        <app-ticket-detail-view
          [ticketDetail]="myTicketDetailData"
          [ticketHeader]="ticketHeader"
          [ticketEditConfiguration]="ticketEditConfiguration"
          [isNewTicketDetailMode]="false"
          [isLoading]="isLoading"
          [activityCodeList]="activityCodeList"
          [technicianList]="technicianList"
          [invoicingCategoryList]="invoicingCategoryList"
          (refreshFdtList)="refreshFdtListComponent()"
          (refreshTicketHeader)="refreshTicketHeader()"
          (isLoadingChange)="isLoadingChange($event)"
          (updateEditFormDirtyState)="updateEditFormDirtyState($event)"
          (removeCommentaire)="removeCommentaire($event)"
          (refreshTicketDetailList)="refreshTicketDetailList()"
        ></app-ticket-detail-view>
        }
      </div>
      }
    </div>

    <!-- FOOTER -->

    <div class="si-edit-footer">
      <!-- CANCEL -->

      <button kendoButton [svgIcon]="allIcons.xIcon" type="button" themeColor="primary" (click)="annuler()">
        {{ "shared.button.cancel" | translate }}
      </button>

      <!-- SAVE -->

      <button
        kendoButton
        [svgIcon]="allIcons.checkIcon"
        type="submit"
        themeColor="success"
        [disabled]="!editform.valid || isLoading || editform.pristine == true"
      >
        {{ "shared.button.save" | translate }}
      </button>
    </div>
  </form>
</div>
